/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GetCurrenciesResult {
  Error = 0,
  Success = 1,
}
